export const name: string = 'Drill Down Container';
export const moduleName: string = 'pdc-widget-drill-down';
export const icon: string = 'zoom-in';
export const namespace: string = 'business-intelligence';
export const group: string = 'Layout';
export const themeId: string = 'pdc-widget-drill-down'; //Theme ID (to SELECT and EXPAND it in Theme dialog)

export const themeFields = {
    headerPlaceHolder: 'pdc-widget-drill-down-header-place-holder',
    updatePrevWidgetOnBack: 'pdc-widget-drill-dwon-update-prev-widget-on-back',
    updateDelayInterval: 'pdc-widget-drill-down-update-delay-interval'
};
